<template>
    <div class="latest-notice">
        <div class="notice-content content">
            <ul class="list">
                <li>
                    <!-- <router-link
                        :to="{
                            name: 'instructions',
                            query: {
                                docId: docid_compile(
                                    notify.url.match(/d\/(.*?)\/edit/)[1]
                                )
                            }
                        }"
                        target="_blank"
                        >{{ notify.message }}</router-link
                    > -->
                    <div class="notify-msg" v-html="notify.message"></div>
                    <span class="time">{{ notify.created_at }}</span>
                </li>
            </ul>
            <div class="operate-box d-flex">
                <router-link
                    v-if="notify.url"
                    class="v-btn check-link gradient-bg"
                    :to="{
                        name: 'instructions',
                        query: {
                            docId: docid_compile(
                                notify.url.match(/d\/(.*?)\/edit/)[1]
                            ),
                        },
                    }"
                    target="_blank"
                >
                    {{ $TL.check }}</router-link
                >
                <v-btn class="close-btn" @click="$emit('closeLatestNoticeBox')">
                    <span>{{ $TL.closure }}</span>
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import { compileStr } from "@/utils/util.js";

export default {
    name: "latest-notice",
    props: {
        notify: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {};
    },
    components: {},

    created() {},
    mounted() {},
    beforeDestroy() {},
    methods: {
        docid_compile(docId) {
            return compileStr(docId);
        },
    },
};
</script>

<style lang="scss">
.latest-notice {
    width: 384px;

    .notice-content {
        padding: 16px;
    }

    .list {
        .notify-msg {
            font-size: 14px;
            line-height: 1.5em;
            padding-bottom: 8px;

            > p:nth-last-child(1) {
                margin-bottom: 0;
            }
        }

        .notify-msg {
            font-size: 14px;
            line-height: 1.5em;
            padding-bottom: 8px;
        }

        .time {
            font-size: 12px;
            color: rgba(#000, 0.45);
        }
    }

    .operate-box {
        margin-top: 26px;
        justify-content: flex-end;

        .v-btn {
            display: inline-block;
            padding: 6px 15px;
            margin-left: 16px;
            font-size: 14px;
            border: 1px solid rgba(#000, 0.15);
            line-height: 1.2;
            border-radius: 32px;
        }

        .check-link {
            color: $color-white !important;
        }

        .close-btn {
            transition: background 0.35s ease;

            &:hover {
                background-color: rgba(#000, 0.12);
                span {
                    color: $color-font;
                }
            }
        }
    }
}
</style>
